import { PageLayout } from '~/components/PageLayout/PageLayout';
import { Schema } from './components/district-form.schema';
import { withPrivateRoute } from '~/hocs/withPrivateRoute';
import { DistrictForm } from './components/district-form';
import { useCreateDistrictMutation } from '../mutations';
import { Fragment } from 'react/jsx-runtime';
import { useNavigate } from 'react-router';

export const Page = withPrivateRoute(() => {
  const mutation = useCreateDistrictMutation();
  const navigate = useNavigate();

  async function onSubmit(payload: Schema) {
    const { data } = await mutation.mutateAsync(payload);
    navigate(`../${data.id}`);
  }

  return (
    <Fragment>
      <PageLayout.Heading text="Skapa distrikt" />

      <PageLayout.Section>
        <DistrictForm onSubmit={onSubmit} isLoading={mutation.isPending} mode="create" />
      </PageLayout.Section>
    </Fragment>
  );
});
